<template>
  <div class="site-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index) in breadcrumb" :key="index">
        <span
          v-if="item.redirect==='noRedirect'||index==breadcrumb.length-1"
          class="no-redirect"
        >{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import pathToRegexp from 'path-to-regexp'
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["breadcrumb"])
  },
  methods: {
    handleLink(item) {
      const { redirect, path } = item;
      if (redirect) {
        this.$router.push({path:redirect});
        return;
      }
    //   console.log(this.pathCompile(path))
      this.$router.push(this.pathCompile(path));
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    }
    // clickBread (i) {

    //   this.$router.push({name: breadcrumb.routeName, params: breadcrumb.params})
    // }
  }
};
</script>
<style >


</style>



// WEBPACK FOOTER //
// src/components/breadcrum.vue